import { Box, BoxProps } from '@mui/material'
import useDialog from '~/src/hooks/useDialog'
import ForgotPasswordDialog, {
  ForgotPasswordDialogProps
} from '~/src/components/auth/dialogs/forgot-password/ForgotPasswordDialog'
import { DialogNameEnum } from '~/src/types/DialogNameEnum'

interface Props extends BoxProps {
  ForgotPasswordDialogProps?: ForgotPasswordDialogProps,
}

const LoginForgotPasswordLink = ({ children, ForgotPasswordDialogProps, ...boxProps }: Props) => {
  const { present } = useDialog()

  const _handleOnClick = () => {
    present<ForgotPasswordDialogProps>(
      ForgotPasswordDialog,
      DialogNameEnum.AUTH_FORGOT_PASSWORD,
      ForgotPasswordDialogProps
    )
  }

  return (
    <Box
      component='span'
      sx={{
        cursor: 'pointer',
        textDecoration: 'underline',
        color: 'inherit',
        textAlign: 'center'
      }}
      onClick={_handleOnClick}
      {...boxProps}
    >
      {children}
    </Box>
  )
}

export default LoginForgotPasswordLink
